import React, { ReactNode, Suspense, useEffect } from "react";
import Wrapper from "../component/Wrapper";
import Main from "../component/Main";

import Content from "../component/Content";
import Loader from "../component/Loader";
import { Outlet } from "react-router-dom";
import Navbar from "../component/navbar/Navbar";
import Sidebar from "../component/sidebar/Sidebar";
import { SidebarItemsType } from "../types/sidebar";
import { GalleryHorizontal, MapPin, Network, Tag, Users, Receipt, Tags , Package, Boxes, Box} from "lucide-react";
import Footer from "../component/Footer";

interface DashboardProps {
  children?: ReactNode;
}

export const Stockanywhere: React.FC<DashboardProps> = ({ children }) => {


    const appProductSection = [
        // {
        //     href: "/assets", 
        //     icon: GalleryHorizontal,
        //     title: "Assets",
        // },
        {
            href: "/channels", 
            icon: Network,
            title: "Channels",
        },
        // {
        //     href: "/customers", 
        //     icon: Users,
        //     title: "Customers",
        // },
        // {
        //     href: "/orders", 
        //     icon: Receipt,
        //     title: "Orders",
        // },
        //  {
        //     href: "/locations", 
        //     icon: MapPin,
        //     title: "Locations",
        // },
        {
            href: "/products", 
            icon: Tag,
            title: "Products",
        },
        {
            href: "/product_varieties", 
            icon: Tags,
            title: "Product Variants",
        },
    ] as unknown as SidebarItemsType[];

    const appChannelSection = [
        // {
        //     href: "/amazon", 
        //     icon: Store,
        //     title: "Amazon",
        //     children: [

        //     ],
        //  }, 
        //  {
        //     href: "/google_merchant_centre", 
        //     icon: Store,
        //     title: "Google Merchant Center", 
        //     children: [

        //     ],
        // },   
        // {
        //     href: "/shopify", 
        //     icon: ShoppingCart,
        //     title: "Shopify",
        //     children: [
                         
        //     ],
        // },
        // {
        //     href: "/takealot", 
        //     icon: ShoppingCart,
        //     title: "Takealot", 
        //     children: [

        //     ],
        // },      
        // {
        //     href: "/woocommerce", 
        //     icon: ShoppingCart,
        //     title: "WooCommerce", 
        //     children: [

        //     ],
        // } 
    ] as unknown as SidebarItemsType[];


    const navItems = [
        {
            title: "Manage:",
            pages: appProductSection,
        },
        {
            title: "Application Data:",
            pages: appChannelSection,
        }
    ];

    return (
    
        <React.Fragment>
            <Wrapper>
                <Sidebar items={navItems} />
                <Main>
                    <Navbar />
                    <Content>
                        <Suspense fallback={<Loader />}>
                            {children}
                            <Outlet />
                        </Suspense>
                    </Content>
                    <Footer />
                </Main>
            </Wrapper>
        </React.Fragment>
    )
};
